import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut} from 'firebase/auth';
import { auth } from '../Firebase/firebaseConfig/firebase';
import '../../style/Login.css'
import { Link } from "react-router-dom"

const AuthDetails = () => {
const [authUser, setAuthUser] = useState(null);

useEffect(() => {
    const listen = onAuthStateChanged(auth, (user) => {
    if (user){
        setAuthUser(user);
    } else{
        setAuthUser(null);
    }        
    });
    return () => {
    listen();
    };
}, []);

    const userSignOut = () => {
    signOut(auth).then(() => {
    console.log('Cierre de sesión exitoso');
    })
    .catch((error) => console.log(error));
};

    return (
    <div>
        {authUser ? <><p className="fs-2 text-center">{'Bienvenido/a '}{authUser.email}</p>
        <Link to="/carrito">
					<button className="btn btn-success text-light mt-3 mb-3" >Ver mi Carrito</button>
				</Link>
        <button className="btn btn-info text-light mt-3 mb-3" style={{ width: '100%' }} onClick={userSignOut}>Cerrar sesión</button></> : (
        <p className='login-text'>Se ha cerrado su sesión correctamente.</p>
    )}
    </div>
);
};

export default AuthDetails;